import {
  WARE_HOUSE_API,
  WARE_HOUSE_API_REMOVE,
} from "shared/constants/api-endpoint";
import { RemovedEntityModel } from "shared/models/removed-entity-model";
import { apiClient } from "shared/plugins/http-service";
import { WareHouseModel } from "./ware-house.models";

export const getWareHouseList = async () => {
  return await apiClient.getHttp<WareHouseModel[]>(`${WARE_HOUSE_API}`);
};

export const removeWareHouse = async (
  removedModel: RemovedEntityModel<number>
) => {
  const response = await apiClient.postHttp(
    `${WARE_HOUSE_API_REMOVE}`,
    removedModel
  );
  return response;
};

export const getWareHouseById = async (id: number) => {
  return await apiClient.getHttp<WareHouseModel>(`${WARE_HOUSE_API}/${id}`);
};

export const addWareHouse = async (model: WareHouseModel) => {
  const response = await apiClient.postHttp<number>(`${WARE_HOUSE_API}`, model);
  return response;
};

export const updateWareHouse = async (model: WareHouseModel) => {
  const response = await apiClient.putHttp(`${WARE_HOUSE_API}`, model);
  return response;
};
